import * as React from 'react';
import './AccountInfo.scss';
import UserModel from 'src/model/user.model';
import LocaleFormating from 'src/translation/localeFormating';
import AccountInfoHeader from '../AccountInfoHeader';
import AccountInfoFooter from '../AccountInfoFooter';
import Checkbox from 'src/components/common/Checkbox';
import AddressModel from 'src/model/address.model';
import { goToBillingAddress, billingAddressUrl } from 'src/utils/navigation';

interface IAccountInfoProps {
  userData: UserModel;
  t?: any;
}

function formatAddress(address: AddressModel): string {
  return `${address.addressLine1}, ${address.addressLine2} ${address.addressLine3} ${address.addressLine4}, ${address.stateCode} ${address.postalCode}`;
}

export function AccountInfo(props: IAccountInfoProps) {
  const accountNumber = props.userData ? props.userData.accountId : '';
  const userId = props.userData ? props.userData.clientIdentity : '';

  const rawBalance =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.balance
      : null;
  const rawLimit =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.creditLimit
      : null;

  const balance = rawBalance
    ? LocaleFormating.formatCurrency(parseFloat(rawBalance))
    : '';
  const limit = rawLimit
    ? LocaleFormating.formatCurrency(parseFloat(rawLimit))
    : '';
  const phone = props.userData.mobileNumber;
  const email = props.userData.email;

  const billingAddress =
    props.userData && props.userData.billingAddress
      ? formatAddress(props.userData.billingAddress)
      : '';
  const { t } = props;

  return (
    <div className="rp-accountinfo">
      <AccountInfoHeader />

      <div className="rp-accountinfo--content">
        <h1>{t('accountInfo.personalInfo')}</h1>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('accountInfoHeader.accountNumber')}:
              </div>
              <div className="rp-accountinfo--item-detail">{accountNumber}</div>
            </div>
            {/* <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">Balance:</div>
              <div className="rp-accountinfo--item-detail">{balance}</div>
            </div> */}
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('common.phone')}:
              </div>
              <div className="rp-accountinfo--item-detail">{phone}</div>
            </div>
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('accountInfo.billingAddress')}:
              </div>
              <div className="rp-accountinfo--item-detail">
                <div>{billingAddress}</div>
                <div className="rp-accountinfo--request-change">
                  <div onClick={e => goToBillingAddress()}>
                    <a href={billingAddressUrl()}>
                      {t('accountInfo.requestChange')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('common.userId')}:
              </div>
              <div className="rp-accountinfo--item-detail">{userId}</div>
            </div>
            {/* <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">Credit Limit:</div>
              <div className="rp-accountinfo--item-detail">{limit}</div>
            </div> */}
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('common.email')}:
              </div>
              <div className="rp-accountinfo--item-detail">{email}</div>
            </div>
            <div className="col-6 col-md-3">
              {/* <div className="rp-accountinfo--item-title">Send Invoices directly to:</div>
              <div className="rp-accountinfo--item-detail">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-6">
                      <Checkbox
                        name="Email"
                        value={"email"}
                        checked={true}
                        onChange={() => console.log("checked")} // TODO
                      />
                    </div>
                    <div className="col-6">
                      <Checkbox
                        name="Fax"
                        value={"fax"}
                        checked={false}
                        onChange={() => console.log("checked")} // TODO
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <AccountInfoFooter />
    </div>
  );
}
